import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ArrowBigUp = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M28 16C28 18.206 26.206 20 24 20C22.958 20 21.971 19.601 21.221 18.877C21.215 18.871 21.208 18.864 21.202 18.858L20 17.632V23.999C20 26.205 18.206 27.999 16 27.999C13.794 27.999 12 26.205 12 23.999V17.634L10.835 18.821C10.084 19.572 9.053 19.999 8 19.999C5.794 19.999 4 18.205 4 15.999C4 14.946 4.427 13.915 5.171 13.17L13.171 5.17002C13.916 4.42502 14.946 3.99902 16 3.99902C17.054 3.99902 18.084 4.42602 18.828 5.17002L26.828 13.17C27.572 13.915 28 14.945 28 15.999V16ZM22.619 17.447C22.993 17.804 23.482 18 24 18C25.103 18 26 17.103 26 16C26 15.473 25.787 14.958 25.414 14.586L17.414 6.58602C17.042 6.21402 16.526 6.00002 16 6.00002C15.474 6.00002 14.958 6.21302 14.586 6.58602L6.586 14.586C6.214 14.958 6 15.474 6 16C6 17.103 6.897 18 8 18C8.526 18 9.042 17.787 9.414 17.414L12.286 14.487C12.57 14.197 13.002 14.108 13.378 14.262C13.754 14.416 14 14.782 14 15.188V24C14 25.103 14.897 26 16 26C17.103 26 18 25.103 18 24V15.185C18 14.779 18.246 14.413 18.622 14.259C18.998 14.105 19.43 14.194 19.714 14.484L22.62 17.446L22.619 17.447Z" />
	</svg>
);

export default ArrowBigUp;
